import React from "react";

const ENLACE_GRUPO_WHATSAPP =
  "https://chat.whatsapp.com/BCyI0OG61Td3sU1F5sEOop";

export const ModalConfirmacionPago = ({ show, onClose }) => {
  //=========================================
  // SI EL MODAL NO ESTÁ ACTIVO
  //=========================================

  if (!show) return null;

  //=========================================
  // CERRAR Y RECARGAR PÁGINA
  //=========================================

  const cerrarYRecargar = () => {
    // Cerrar modal
    onClose();

    // Recargar página
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  //=========================================
  // UNIRSE AL GRUPO DE WHATSAPP
  //=========================================

  const unirseWhatsApp = () => {
    // Abrir WhatsApp
    window.open(ENLACE_GRUPO_WHATSAPP, "_blank", "noopener,noreferrer");

    // Cerrar modal y recargar
    onClose();
  };

  //=========================================
  // RENDERIZAR MODAL
  //=========================================

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        background: "rgba(0,0,0,.6)",
        zIndex: 1060,
      }}
    >
      {/*=====================================
        CONTENEDOR DEL MODAL
      =====================================*/}

      <div
        className="modal-dialog modal-dialog-centered"
        style={{
          maxWidth: "480px",
          width: "92%",
          margin: "auto",
        }}
      >
        <div
          className="modal-content border-0 shadow-lg"
          style={{
            borderRadius: "25px",
            overflow: "hidden",
          }}
        >
          {/*=====================================
            HEADER
          =====================================*/}

          <div
            className="text-white text-center p-4 position-relative"
            style={{
              background: "linear-gradient(135deg,#44296a 0%,#370a33 100%)",
            }}
          >
            {/*=================================
              BOTÓN X
            =================================*/}

            <button
              type="button"
              onClick={cerrarYRecargar}
              aria-label="Cerrar"
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                border: "none",
                background: "rgba(255,255,255,.15)",
                color: "#ffffff",
                fontSize: "1.4rem",
                lineHeight: "1",
                cursor: "pointer",
              }}
            >
              ×
            </button>

            {/*=================================
              ICONO CHECK
            =================================*/}

            <div
              className="mx-auto mb-3 d-flex justify-content-center align-items-center"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                background: "#ffffff",
              }}
            >
              <span
                style={{
                  fontSize: "2.5rem",
                  color: "#198754",
                  fontWeight: "bold",
                }}
              >
                ✓
              </span>
            </div>

            {/*=================================
              TITULO
            =================================*/}

            <h3 className="fw-bold mb-1">¡Pago recibido!</h3>

            <p className="mb-0">Tu pago fue recibido correctamente.</p>
          </div>

          {/*=====================================
            BODY
          =====================================*/}

          <div className="modal-body text-center p-4">
            <p
              className="mb-4"
              style={{
                fontSize: "1.05rem",
                lineHeight: "1.6",
                color: "#444",
              }}
            >
              Hemos recibido y registrado tu pago.
              <br />
              Ahora puedes unirte al grupo oficial de WhatsApp de Teen Missions
              Perú.
            </p>

            {/*=================================
              BOTÓN WHATSAPP
            =================================*/}

            <button
              type="button"
              onClick={unirseWhatsApp}
              className="btn btn-success btn-lg w-100 rounded-pill"
              style={{
                fontWeight: "bold",
                padding: "12px 20px",
              }}
            >
              <i className="bi bi-whatsapp me-2"></i>
              Unirme al grupo de WhatsApp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
